import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fc5971e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-y-9" }
const _hoisted_2 = { class: "card-global flex justify-between items-center relative" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "user-details-content flex items-start space-x-9" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user-details-photo card-global space-y-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    src: "#",
    alt: "#",
    class: "w-48 h-48 bg-gray-500 rounded-full"
  })
], -1))
const _hoisted_6 = { class: "flex-grow bg-gray-50 rounded-lg p-3 border border-gray-100" }
const _hoisted_7 = {
  key: 0,
  class: "mb-3 flex flex-wrap gap-2 border-b pb-3"
}
const _hoisted_8 = {
  key: 1,
  class: "bg-white divide-y"
}
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 p-2 text-left text-gray-400" }, "ID", -1))
const _hoisted_11 = { class: "flex-1 min-w-0 p-2 text-left" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_14 = { class: "flex-1 p-2 text-left" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1 p-2 capitalize text-left text-gray-400" }, " Email ", -1))
const _hoisted_17 = { class: "flex-1 p-2 text-left" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "flex-1 p-2 text-left text-gray-400" }
const _hoisted_20 = { class: "flex-1 p-2 text-left" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_23 = { class: "flex-1 p-2 text-left" }
const _hoisted_24 = { class: "flex" }
const _hoisted_25 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_26 = { class: "flex-1 p-2 text-left" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_29 = { class: "flex-1 p-2 text-left" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_32 = { class: "flex-1 p-2 text-left" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_35 = { class: "flex-1 p-2 text-left" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = { class: "flex-1 p-2 capitalize text-left text-gray-400" }
const _hoisted_38 = { class: "flex-1 p-2 text-left" }

import BackButton from "@/components/common/BackButton.vue";
import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { InfoFields, TextButton, ActionMenu } from "@/components/common/";
import { TrashIcon } from "@heroicons/vue/outline";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { UserActions } from "@/store/modules/user/actions";
import { UserGetters } from "@/store/modules/user/getters";
import StatusLabel from "@/components/common/StatusLabel.vue";
import PublicId from "@/components/common/PublicId.vue";
import DeactivateEntityModal from "@/components/common/DeactivateEntityModal.vue";
import { t } from "@/i18n";
import { AuthGetters } from "@/store/modules/auth";
import EnbekUserPanel from "@/components/enbek/EnbekUserPanel.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();
const store = useStore();
const toast = useToast();

const user = computed(() => store.getters[UserGetters.GET_CURRENT]);
const deactivateModalShow = ref(false);
const activeTab = ref<"details" | "enbek">("details");
const identity = computed(() => store.getters[AuthGetters.GET_USER_IDENTITY]);
const canManageEnbek = computed(() =>
  Array.isArray(identity.value?.permissions) &&
  identity.value.permissions.includes("ENBEK_MANAGE")
);

onMounted(async () => {
  await store.dispatch(UserActions.FETCH_ONE, route.params.id);
});

const confirmDeactivate = async (coordinatorId?: string) => {
  const id = String(route.params.id);
  try {
    await store.dispatch(UserActions.DELETE, { id, coordinatorId });
    toast.success(t("approval.submitted"));
    deactivateModalShow.value = false;
    await router.push({ name: "UserList" });
  } catch {
    toast.error(t("deactivate.error"));
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackButton, {
      to: { name: 'UserList' },
      class: "mb-4"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("userDetails.title")), 1),
        _createVNode(_unref(ActionMenu), {
          class: "top-1/2 right-0",
          actions: [
          {
            text: _unref(t)('userDetails.delete'),
            icon: _unref(TrashIcon),
            iconColor: 'text-red-500',
            action: () => {
              deactivateModalShow.value.value = true;
            },
          },
        ]
        }, null, 8, ["actions"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_unref(canManageEnbek))
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["px-4 py-2 rounded-lg", activeTab.value === 'details' ? 'bg-primary-300 text-white' : 'bg-white border']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'details'))
                }, _toDisplayString(_unref(t)("userDetails.title")), 3),
                _createElementVNode("button", {
                  class: _normalizeClass(["px-4 py-2 rounded-lg", activeTab.value === 'enbek' ? 'bg-primary-300 text-white' : 'bg-white border']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'enbek'))
                }, _toDisplayString(_unref(t)("enbek.tab")), 3)
              ]))
            : _createCommentVNode("", true),
          (_unref(user))
            ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                (activeTab.value === 'details')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("li", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(PublicId, {
                            value: _unref(user).id
                          }, null, 8, ["value"])
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("profile.login")), 1),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(user).login), 1)
                      ]),
                      _createElementVNode("li", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(user).email), 1)
                      ]),
                      _createElementVNode("li", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)('profile.phone')), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(user).phone || '—'), 1)
                      ]),
                      _createElementVNode("li", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("common.iin")), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(user).iin), 1)
                      ]),
                      _createElementVNode("li", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)("common.name")), 1),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(user).name), 1)
                      ]),
                      _createElementVNode("li", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)("common.surname")), 1),
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(user).surname), 1)
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(t)("common.company")), 1),
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(user).companyName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("common.job")), 1),
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(user).jobName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(t)("common.status")), 1),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(StatusLabel, {
                            label: _unref(user).status
                          }, null, 8, ["label"])
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_unref(canManageEnbek) && activeTab.value === 'enbek' && _unref(user))
            ? (_openBlock(), _createBlock(EnbekUserPanel, {
                key: 2,
                "user-id": String(_unref(route).params.id)
              }, null, 8, ["user-id"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(DeactivateEntityModal, {
      show: deactivateModalShow.value,
      onHide: _cache[2] || (_cache[2] = ($event: any) => (deactivateModalShow.value = false)),
      onConfirm: confirmDeactivate
    }, null, 8, ["show"])
  ], 64))
}
}

})